import { useRouting } from '@tbitop/routing';
import { isEmpty } from 'lodash-es';
import type { ObjektQuery } from '../../../../infrastructure/graphql/__generated__/objekt';
import { AufgabenListItem } from './aufgaben-list-item';

type Unarray<T> = T extends (infer U)[] ? U : T;
type Objekt_objekt_aufgaben = Unarray<ObjektQuery['objekt']['aufgaben']>;

type AufgabenListProps = {
  aufgaben: Objekt_objekt_aufgaben[];
  showAbschliessenButtons?: boolean;
};

export const AufgabenList = ({ aufgaben, showAbschliessenButtons }: AufgabenListProps) => {
  const { query } = useRouting();

  if (isEmpty(aufgaben)) {
    return null;
  }

  return (
    <ul className="flex flex-col gap-100">
      {aufgaben.map(aufgabe => (
        <AufgabenListItem key={aufgabe.id} aufgabe={aufgabe} href={{ query: { ...query, aufgabenId: aufgabe.id } }} showAbschliessenButtons={showAbschliessenButtons}/>
      ))}
    </ul>
  );
};
